var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.policy'),"tabs":_vm.tabs,"current-tab":_vm.currentTab},on:{"update:currentTab":function($event){_vm.currentTab=$event},"update:current-tab":function($event){_vm.currentTab=$event}}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId,"type":_vm.currentTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }